"use strict";
let popovers = []; // Массив Popovers


document.addEventListener('DOMContentLoaded', function() {
	// let DEFAULT_CITIES = {
	// 	names: ['Київ', 'Харків', 'Львів', 'Одеса', 'Дніпро'],
	// };


	const DEBUG = window.calc_handbooks.calc.IS_DEV
	const CALC_TYPE = 'zk'
	const COOKIE_NAMES = {
		'uuid': CALC_TYPE + '_uuid'
	}
	const today = new Date()
	const defaultOrderPolisStart = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+((today.getDate()+1).toString().padStart(2, "0"))
	// const DEFAULT_ERR_TEXT = 'Для вирішення проблеми зверніться до наших операторів'

	const API = 'https://api.greentravel.ua/api'

	const CALC_URL = (window.location.href.includes('calcs_test'))
		? 'https://greentravel.ua/calcs_test'
		: 'https://greentravel.ua/calcs_vue'

		DEBUG ? console.log('CALC_URL: ', CALC_URL) : null

	const CALC_TEST = window.location.href.includes('calcs_test')

	const APP = Vue.createApp({
		data(){ return{
			calcFields: {
				trip_country:'eu',
				trip_duration:0,
				trip_duration_days:'15 днів',
				transport_type:1,
				promocode:'',
				orderCarMark: {
					id:null,
					name:null
				},
				orderCarModel:{
					id:null,
					name:null
				},
				insurantPhone:'',
				email:'',
				orderPolisStart: defaultOrderPolisStart,
				insurance_company: '',
				gov_num: '',
				orderVin: '',
				orderCarYear: '',
				insurantBirth: '',
				insurantInn: '',
				insurantSurname: '',
				insurantSurnameLatin: '',
				insurantName: '',
				insurantNameLatin: '',
				insurantDocSeries: '',
				insurantDocNumber: '',
				cashback: {
					selected: 'phone',
					phone: {value:''},
					bankcard: {value:''},
					zsu: {}
				},
				cashback_phone_changed:false,
				city: {
					id:'',
					name:''
				},
				comment: '',
				assistme: {
					need:true,
					price:null,
					old_price:null,
				},
				vehicles: [],
				checkboxCallMe: false,
				checkboxAgreePublicOffer: true
			},


			calcStatus: {
				sendSms_searchInsurantByPhone__count: 0, // счетчик отправки смс searchInsurantByPhone
				readySteps: {
					step1:false,
					step2:false,
					step3:false,
				},
				isTest:false,
				enableAssist:true,
				selectedInsurance:null, // выбранная страховая
				calcFillingMethod:'default', // или uploadDocs, или himself
				isPromocodeUsed: false,
				isLoadCarInfoFromAPI: false, // Костыль, который потом переделать. Нужен чтобы tomSelect правильно обрабатывал автоматическое заполнение инфы о машине и правильно работал с ручным заполнением
				messages:{
					promocode: {
						error: null,
					}
				}
			},


			calcPrice: {
				by_companies: null, // или массив, если есть ответы
				has_cashback: false,
				cashback: null,
				// now: null,
				// old: null,
			},


			fillingInsurantByPhone: {
				allow: false,
				sms_code: '',
				sms_confirmed: false,
				// sms_confirmed: true,
				insurant_data: {} // для использования при поиске по номеру
				// insurant_data: {vehicles:[{"brand":"Skoda","model":"Octavia Scout","				vin":"111111111111","state_number":"AX0000AE","address":"Бахчисарай","year":"2021"},{"brand":"Skoda","model":"Karoq","vin":"1111111111111111","state_number":"AX0320HP","address":"Харків (Харківська)","year":"2021"}]}
			},

			policyCodeConfirmation: {
				// code: '',
				status: '',
				is_confirmed: false,
			},

			SMScode: '',
			policyCode: '',
			paymentURL: '',
			citiesDefault: [],
			// uuid: '',
			// uuid: getCookie(COOKIE_NAMES.uuid) ? getCookie(COOKIE_NAMES.uuid) : '',
			uuid: '',
			draft: {}
		}},


		methods: {
			setClass(params) {
				DEBUG ? console.log('setClass:', params):null
				let el = document.querySelector(params.el);
				if(params.class_add != '') el.classList.add(params.class_add);
				if(params.class_remove != '') el.classList.add(params.class_remove);
			},


			gotoStep(step) {
				DEBUG ? console.log('step: '+step):null

				let prevStep = 'step'+(step-1)
				let stepEl = document.querySelector('.calcStep.calcStep--' + step)
				let prevStepEl = document.querySelector('.calcStep.calcStep--' + (step-1))

				this.calcStatus.readySteps[prevStep] = true
				prevStepEl.classList.add('_passed')
				// prevStepEl.classList.add('_disabled')

				if(step > 1 && window.calc_handbooks.calc.IS_CMS_EMBED) {
					document.querySelector('body').classList.add('calc_step_passed')
				}



				// if(step == 3 && this.calcStatus.calcFillingMethod == 'uploadDocs') {
				// 	DEBUG ? console.log('pay', this.draft.payment_url):null
				// 	window.location.href = this.draft.payment_url // переход на страницу оплаты

				// } else
				if(step >= 2) {
					stepEl.classList.remove('_not_started')
					document.querySelector('.calcStep--'+step+' .anchor._heading').scrollIntoView({
						behavior: 'smooth'
					})
				}
			},



			checkStep2() {
				const checkValidate = this.validateAll()
				if(checkValidate) {
					const btnSubmitStep2 = document.querySelector('.btnSubmitStep2')
					btnSubmitStep2.classList.add('_loading')

					this.getdraft()
					.then(() => {
						this.gotoStep(3)
						// this.smsCodeSend()
					})
					.finally(() => {
						btnSubmitStep2.classList.remove('_loading')
					})
				}
			},



			checkPromocode() {
				axios.get(API + '/orders/promocode', {
					params: {
						polis_type: 'greencard',
						promocode: this.calcFields.promocode
					}
				})
				.then((response) => {
					DEBUG ? console.log(response):null
					this.calcStatus.isPromocodeUsed = true
					this.getPrice()
					this.showPromocode('hide_window')
				})
				.catch((error) => {
					DEBUG ? console.log(error):null
					this.calcStatus.isPromocodeUsed = false
					this.calcStatus.messages.promocode.error = "Невірний промокод"
				})
			},



			getINN() {
				if(this.calcFields.insurantInn == '') return false

				axios.get(API + '/data/inn', {
					params: {
						search: this.calcFields.insurantInn
					}
				})
				.then((response)=>{
					DEBUG ? console.log(response):null
					if(response.data.status) this.calcFields.insurantBirth = response.data.birth
					let cal = document.getElementById('insurantBirth')
					// cal.flatpickr().setDate(response.data.birth, true, 'Y-m-d')
					window.insurantBirth.setDate(response.data.birth, true, 'Y-m-d')
				})
				.catch((error) => {
					DEBUG ? console.log(error):null
					this.showApiTranslaterdErrors(error.response.data)
				})
			},



			validateAll(el = false, validatePattern = false) {
				const invalidClass = 'is-invalid'
				const validatioWrapClass = 'validation__wrap'
				let noErrorsOverall = true

				let fieldsSelectors = el ? [el] : // проверка разных полей в зависимости от типа заполнения
					['#phone', '#email', '#polisStart', '#gov_num', '#vin', '#carMarkSelect', '#carModelSelect', '#carYearSelect', '#insurantSurname', '#insurantName', '#insurantSurnameLat', '#insurantNameLat', '#insurantBirth', '#cityInsur', '#INN']


				DEBUG ? console.log('(validateAll) noErrorsOverall = ', noErrorsOverall, fieldsSelectors):null

				let firstNotValidEl = null

				fieldsSelectors.forEach(function(fieldSelector, n) {
					let el = document.querySelector(fieldSelector)
					if(el === null) return false

					let field = {
						el: el,
						parent_el: el.parentNode,
						isValid: el.checkValidity(),
						isEmpty: el.value == ''
					}
					if(typeof el._flatpickr != 'undefined')
						el.isEmpty = el._flatpickr.selectedDates[0] == ''


					// если noErrorsOverall хотя бы раз false - то больше не меняется
					if(noErrorsOverall === true)
						// noErrorsOverall = field.isValid == false ? false : true
						noErrorsOverall = (field.isValid && !field.isEmpty)

					let validMsgEl = field.parent_el.querySelector('.' + validatioWrapClass)
					if(validMsgEl) validMsgEl.remove()

					if(field.isValid == false || field.isEmpty) {
						field.el.classList.add(invalidClass)
						field.parent_el.classList.add(invalidClass)

						const validationEl = document.createElement('div')
						validationEl.className = validatioWrapClass
						validationEl.innerHTML = `<div class="validation-invalid">Заповніть це поле</div>`
						field.parent_el.insertAdjacentHTML('beforeend', validationEl.outerHTML)

						// let validMsgEl = document.querySelector(fieldSelector + ' + div')

						if(firstNotValidEl === null) {
							firstNotValidEl = field.el
							firstNotValidEl.scrollIntoView({behavior: "smooth", block: "center"})
						}

					} else {
						DEBUG ? console.log('is-valid', el) : null
						field.el.classList.remove(invalidClass)
						field.parent_el.classList.remove(invalidClass)
					}
				})

				DEBUG ? console.log ('noErrorsOverall: ', noErrorsOverall):null
				return noErrorsOverall
			},


			highlightErrorField(serverErrorResponse) {
				DEBUG ? console.log('highlightErrorField', serverErrorResponse):null
			},


			async saveDraft() {
				if (CALC_TEST) return false
				if(this.uuid === false) return false // значит UUID на этапе получения

				try {
					const ga_id = getCookie('_ga')

					// let cashbackPhone = '+380' + this.calcFields.cashback.phone.value
					// if(this.calcFields.cashbackPhone.zsu ||)	cashbackPhone = ''
					let cashback = {
						phone: 		'',
						bankcard: '',
						zsu: 			false,
					}
					switch (this.calcFields.selected) {
						case 'phone':
							cashback.phone = '+380' + this.calcFields.cashback.phone.value; break;

						case 'bankcard':
							cashback.bankcard = this.calcFields.cashback.bankcard.value; break;

						case 'zsu':
							cashback.zsu = true;
					}

					let submitData = {
						"trip_country": this.calcFields.trip_country,
						"trip_duration": this.calcFields.trip_duration,
						"email": this.calcFields.email,
						"polis_start": this.calcFields.orderPolisStart,
						"upload_docs": false,
						"ga_id": ga_id,
						"comment": this.calcFields.comment,
						"cashback_phone": 	cashback.phone,
						"cashback_to_vsu": 	cashback.zsu,
						"cashback_card": 		cashback.bankcard,
						"insurance_company": this.calcFields.insurance_company,
						"transport": {
							"transport_category_id": this.calcFields.transport_type,
							"car_mark": this.calcFields.orderCarMark.name,
							"car_model": this.calcFields.orderCarModel.name,
							"gov_num": this.calcFields.gov_num,
							"vin": this.calcFields.orderVin,
							"car_year": this.calcFields.orderCarYear
						},
						"city_name": this.calcFields.city.name,
						"insurant": {
							"phone": this.calcFields.insurantPhone,
							"surname": this.calcFields.insurantSurname,
							"name": this.calcFields.insurantName,
							"surname_latin": this.calcFields.insurantSurnameLatin,
							"name_latin": this.calcFields.insurantNameLatin,
							"inn": this.calcFields.insurantInn,
							"birth": this.calcFields.insurantBirth,
						},
						"with_assist_me": this.calcFields.assistme.need,
					}
					if(this.uuid !== '' && this.uuid !== false) submitData.uuid = this.uuid
						else this.uuid = false // отметка что uuid на этапе получения


					if(this.calcFields.insurantDocSeries.length > 0 && this.calcFields.insurantDocNumber.length > 0) {
						submitData.insurant.doc_series = (this.calcFields.insurantDocSeries).toString()
						submitData.insurant.doc_number = (this.calcFields.insurantDocNumber).toString()
					}


					DEBUG ? console.log('saveDraft', submitData):null
					await axios.post(API + '/v2/greencard/draft', submitData, {
						headers: {
							'Access-Control-Allow-Origin': 'https://greentravel.ua',
							'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
							'Access-Control-Allow-Headers': '*',
							'Access-Control-Allow-Credentials': 'true',
						}
					})

					.then((response) => {
						DEBUG ? console.log(response.data):null
						if(this.uuid == '') {
							this.uuid = response.data.uuid
							saveCookie(COOKIE_NAMES.uuid, this.uuid, 10)
						}
					})

					.catch((error) => {
						this.uuid = '' // откатываем к обычному состоянию в случае ошибки
						this.log({
							method:'saveDraft',
							error:error,
							data:this.calcFields
						}, CALC_TYPE+'-error')

						if (error.response) {
							console.log(error.response)
							this.highlightErrorField(error.response.data.message)

						} else if (error.request) {
							console.log(error.request);
						}
					})

				} catch (error) {
					DEBUG ? console.error('Ошибка saveDraft:', error):null
				}

			},



			getdraft() {
				const ga_id = getCookie('_ga')

				let cashback = {
					phone: 		'',
					bankcard: '',
					zsu: 			false,
				}
				switch (this.calcFields.cashback.selected) {
					case 'phone':
						cashback.phone = '+380' + this.calcFields.cashback.phone.value; break;

					case 'bankcard':
						cashback.bankcard = this.calcFields.cashback.bankcard.value; break;

					case 'zsu':
						cashback.zsu = true;
				}

				if(this.calcStatus.calcFillingMethod != 'uploadDocs') {
					let submitData = {
						"trip_country": this.calcFields.trip_country,
						"trip_duration": this.calcFields.trip_duration,
						"email": this.calcFields.email,
						"polis_start": this.calcFields.orderPolisStart,
						"upload_docs": false,
						"ga_id": ga_id,
						"comment": this.calcFields.comment,
						"cashback_phone": 	cashback.phone,
						"cashback_to_vsu": 	cashback.zsu,
						"cashback_card": 		cashback.bankcard,
						"insurance_company": this.calcFields.insurance_company,
						"transport": {
							"transport_category_id": this.calcFields.transport_type,
							"car_mark": this.calcFields.orderCarMark.name,
							"car_model": this.calcFields.orderCarModel.name,
							"gov_num": this.calcFields.gov_num,
							"vin": this.calcFields.orderVin,
							"car_year": this.calcFields.orderCarYear
						},
						"city_name": this.calcFields.city.name,
						"insurant": {
							"phone": this.calcFields.insurantPhone,
							"surname": this.calcFields.insurantSurname,
							"name": this.calcFields.insurantName,
							"surname_latin": this.calcFields.insurantSurnameLatin,
							"name_latin": this.calcFields.insurantNameLatin,
							"inn": this.calcFields.insurantInn,
							"birth": this.calcFields.insurantBirth,
						},
						"with_assist_me": this.calcFields.assistme.need
					}
					if(this.uuid != '') submitData.uuid = this.uuid

					if(this.calcFields.insurantDocSeries.length > 0 && this.calcFields.insurantDocNumber.length > 0) {
						submitData.insurant.doc_series = (this.calcFields.insurantDocSeries).toString()
						submitData.insurant.doc_number = (this.calcFields.insurantDocNumber).toString()
					}

					DEBUG ? console.log(submitData):null

					return axios.post(API + '/v2/greencard', submitData, {
						headers: {
							'Access-Control-Allow-Origin': 'https://greentravel.ua',
							'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
							'Access-Control-Allow-Headers': '*',
							'Access-Control-Allow-Credentials': 'true',
						}
					})

					.then((response) => {
						DEBUG ? console.log(response.data):null
						if(response.data.uuid) {
							// если получили UUID
							this.draft = response.data
							deleteCookie(COOKIE_NAMES.uuid)

							// отключаем загрузку и переходим к оплате
							// submitBtn.classList.remove('_loading')

							// let debugConfirmPayment = DEBUG
							// 	? confirm('Перейти на оплату? (Алерт только на тесте)')
							// 	: true

							// debugConfirmPayment
							// 	? window.location.assign(this.draft.payment_url)
							// 	: null
						} else {
							console.warn('Не удалось получить uuid')
						}
					})

					.catch((error) => {
						this.log({
							method:'getdraft',
							error:error,
							data:this.calcFields
						}, CALC_TYPE+'-error')
						// submitBtn.classList.remove('_loading')

						if (error.response) {
							console.log(error.response)

							this.showApiTranslaterdErrors(error.response.data)

						} else if (error.request) {
							console.log(error.request);
						}
					})


				}
			},



			smsCodeSend() {
				DEBUG ? console.log('smsCodeSend') :  null
				axios.post(API + '/orders/'+this.draft.uuid+'/sms/send', {
					uuid: this.draft.uuid
				},{
					headers: {
						'Access-Control-Allow-Origin': 'https://greentravel.ua',
						'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
						'Access-Control-Allow-Headers': '*',
						'Access-Control-Allow-Credentials': 'true',
					}
				})
				.then((response) => {
					DEBUG ? console.log(response.data):null
					if(response.data.success) {
					} else {
						Swal.fire({
							icon: 'error',
							title: 'Помилка',
							text: JSON.stringify(error.response.data.message, null, '\t'),
						})
					}
				})
				.catch((error) => {
					console.log('SMS SENDING ERROR', error)
					this.log({
						method:'smsCodeSend',
						error:error,
						data:this.calcFields
					}, CALC_TYPE+'-error')
				})
			},


			smsCodeConfirm() {
				DEBUG ? console.log('smsCodeConfirm'):null
				axios.post(API + '/orders/'+this.draft.uuid+'/sms/confirm', {
					code: this.SMScode
				},{
					headers: {
						'Access-Control-Allow-Origin': 'https://greentravel.ua',
						'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
						'Access-Control-Allow-Headers': '*',
						'Access-Control-Allow-Credentials': 'true',
					}
				})
				.then((response) => {
					DEBUG ? console.log(response.data):null
					this.paymentURL = this.draft.payment_url

					if(response.data.success) {
						this.calcStatus.isSMScodeConfirm = true
					}
				})
				.catch((error) => {
					DEBUG ? console.log('SMS CONFIRM ERROR', error) :null
					this.log({
						method:'smsCodeConfirm',
						error:error,
						data:this.calcFields
					}, CALC_TYPE+'-error')
				})
				.then(() => {
					DEBUG ? console.log('smsCodeConfirm finally') :null
					this.paymentURL = this.draft.payment_url
				});
			},


			policyCodeConfirm() {
				DEBUG ? console.log('policyCodeConfirm'):null
				axios.post(API + '/orders/'+this.draft.uuid+'/sms/confirm', {
					code: this.policyCode
				},{
					headers: {
						'Access-Control-Allow-Origin': 'https://greentravel.ua',
						'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
						'Access-Control-Allow-Headers': '*',
						'Access-Control-Allow-Credentials': 'true',
					}
				})
				.then((response) => {
					DEBUG ? console.log(response.data):null
					this.paymentURL = this.draft.payment_url

					if(response.data.success) {
						this.policyCodeConfirmation.is_confirmed = true
					} else {
						document.querySelector('.policyCodeConfirmation__group .wrong_code_text').classList.add('show')
					}
				})
				.catch((error) => {
					DEBUG ? console.log('policyCodeConfirm ERROR', error) :null

					document.querySelector('.policyCodeConfirmation__group .wrong_code_text').classList.add('show')

					this.log({
						method:'policyCodeConfirm',
						error:error,
						data:this.calcFields
					}, CALC_TYPE+'-error')
				})
				.then(() => {
					DEBUG ? console.log('policyCodeConfirm finally') :null
					this.paymentURL = this.draft.payment_url
				});
			},



			goto_checkout() {
				let debugConfirmPayment = DEBUG
					? confirm('Перейти на оплату? (Алерт только на тесте)')
					: true

				debugConfirmPayment
					? window.location.assign(this.draft.payment_url)
					: null
			},



			showPromocode(action = null) {
				let promoEl = document.querySelector('.promocodeField__wrap')
				let promoCheck = document.querySelector('#formfield_havePromocode')

				if(action == 'hide_window') promoCheck.checked = false

				if(promoCheck.checked) {
					promoEl.classList.add('show')
				} else {
					promoEl.classList.remove('show')
				}
			},



			choose_insurance(name) {
				this.calcFields.insurance_company = name
				const insurance = this.calcPrice.by_companies.find(item => item.insurance_company === name)
				this.calcStatus.selectedInsurance = insurance
				this.calcPrice.cashback = insurance?.cashback_amount
			},



			getPrice() {
				axios.post(API + '/v2/greencard/calculate', {
					"trip_country": this.calcFields.trip_country,
					"trip_duration": parseInt(this.calcFields.trip_duration),
					"promocode": this.calcFields.promocode,
					"with_assist_me": this.calcFields.assistme.need,
					"transport": {
						"transport_category_id": parseInt(this.calcFields.transport_type)
					}
				},{
					timeout: 25000,
					headers: {
						'Access-Control-Allow-Origin': 'https://greentravel.ua',
						'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
						'Access-Control-Allow-Headers': '*',
						'Access-Control-Allow-Credentials': 'true',
					}
				})
				.then((response) => {
					DEBUG ? console.log(response.data):null
					this.calcFields.assistme.price = response.data.assist_me_price
					this.calcFields.assistme.old_price = response.data.assist_me_old_price

					let prices = response.data.prices
					prices.sort((a, b) => a.price - b.price)
					this.calcPrice.by_companies = prices

					this.calcPrice.has_cashback = this.calcPrice.by_companies.some(item => item.cashback_amount > 0)
				})
				.catch((error) => {
					this.log({
						method:'getPrice',
						error:error,
						data:this.calcFields
					}, CALC_TYPE+'-error')

					this.calcPrice.by_companies = []

					this.showServerError()
				})
			},





			changeCarMark() {
				const carMarkSelect = document.getElementById('carMarkSelect').tomselect
				let carMark = _.find(carMarkSelect.options, {id:carMarkSelect.getValue()})

				this.calcFields.orderCarMark.id = carMark.id
				this.calcFields.orderCarMark.name = carMark.name

				if(this.calcStatus.isLoadCarInfoFromAPI === false) {
					this.calcFields.orderCarModel = {}

					const carModelSelect = document.getElementById('carModelSelect').tomselect

					carModelSelect.clear()
					carModelSelect.clearOptions()


					let url = API + '/handbooks/cars/'+ this.calcFields.orderCarMark.id +'/models'
					// console.log('url', url)
					axios.get(url)
					.then(function (response) {
						carModelSelect.addOptions(response.data)
					})
				}
			},



			changeCarModel() {
				const carModelSelect = document.getElementById('carModelSelect').tomselect
				let carModel = carModelSelect.options[carModelSelect.getValue()]
				DEBUG ? console.log(carModel) : null
				this.calcFields.orderCarModel.id = carModel.id
				this.calcFields.orderCarModel.name = carModel.name
			},



			// Тут разные параметры для инициации календаря (на основе vue-директивы, например: v-calendar='init: "polisStart"')
			getCalendarInitParams(name) {
				if(name == 'polisStart') {
					return {
						minDate: defaultOrderPolisStart
					}
				}


				if(name == 'insurantBirth') {
					return {
						minDate: (today.getFullYear() - 80)+'-'+(today.getMonth()+1)+'-'+((today.getDate()).toString().padStart(2, "0")),
						maxDate: (today.getFullYear() - 18)+'-'+(today.getMonth()+1)+'-'+((today.getDate()).toString().padStart(2, "0"))
					}
				}

				return false
			},




			setCity(cityID) {
				DEBUG ? console.log('setCity = '+cityID):null
				let citySelect = document.getElementById('cityInsur').tomselect
				citySelect.setValue([cityID])
			},



			// Тут разные параметры для инициации TomSelect (на основе vue-директивы, например: v-smartselect='init: "carModel"')
			getTomSelectInitParams(name, instance) {
				if(name == 'city') return {
					valueField: 'mtsbuId',
					labelField: 'name',
					searchField: 'name',
					create: true,
					onChange: function(cityID) {
						// console.log('change')
						// console.log(this)
						// console.log('======')
						instance.calcFields.city = {
							id: cityID,
							name: this.options[cityID].name
						}
					},
					load: function(query, callback) {
						let url = API + '/handbooks/cities?search=' + encodeURIComponent(query)
						document.querySelector('#cityInsur').classList.add('_loading')
						DEBUG ? console.log('url', url):null
						axios.get(url)
						.then(function (response) {
							DEBUG ? console.log(response.data):null
							callback(response.data)
						})
						.catch((err) => {
							DEBUG ? console.log('city catch error', err):null
							callback()
						})
						.then(()=>{
							document.querySelector('#cityInsur').classList.remove('_loading')
						})
					},
					render: {
						option: function(item, escape) {
							const optionName = item.region
								? item.name + ' (' + item.region.caption + ')'
								: item.name
							return `<div class="option"> ${escape(optionName)}</div>`;
						},
						item: function(item, escape) {
							const itemName = item.region
								? item.name + ' (' + item.region.caption + ')'
								: item.name
							return `<div class="item">${escape(itemName)}</div>`;
						},

						no_results:function(data,escape){
							return '<div class="no-results"></div>';
						}
					},
				}


				if(name == 'carModel') {
					return {
						createOnBlur: true,
						create: true,
						valueField: 'id',
						labelField: 'name',
						searchField: 'name',
						render: {
							option: function(item, escape) {
								return `<div class="option">${escape(item.name)}</div>`;
							},
							item: function(item, escape) {
								return `<div class="item">${escape(item.name)}</div>`;
							}
						},
					}
				}


				if(name == 'carMark') {
					return {
						createOnBlur: true,
						create: true,
						valueField: 'id',
						labelField: 'name',
						searchField: 'name',
						render: {
							option: function(item, escape) {
								return `<div class="option">${escape(item.name)}</div>`;
							},
							item: function(item, escape) {
								return `<div class="item">${escape(item.name)}</div>`;
							}
						},
					}
				}

				return false
			},



			findCarInfoByHisNumber(carnum = false) {
				if(carnum == false) carnum = this.calcFields.gov_num
				if(carnum.length < 8) return false
				this.calcStatus.isLoadCarInfoFromAPI = false

				let govNumEl = document.getElementById('gov_num')
				// let carMarkSelect = document.getElementById('carMarkSelect').tomselect
				// let carModelSelect = document.getElementById('carModelSelect').tomselect
				let carYearSelect = document.getElementById('carYearSelect').tomselect

				DEBUG ? console.log('findCarInfoByHisNumber: '+carnum):null
				govNumEl.classList.add('_loading')

				// axios.get(API + '/handbooks/cars/find', {
				axios.get(API + '/handbooks/cars/findBot', {
					timeout: 10000,
					params: {
						search: carnum,
					}
				})
				.then((response)=>{
					// const resp =  response.data[0]
					const resp =  response.data
					// DEBUG ? console.log(response):null
					DEBUG ? console.log('findCarInfoByHisNumber data:', resp):null
					if(typeof resp == 'undefined') throw new Error('Error findCarInfoByHisNumber(): empty response')

					this.calcStatus.isLoadCarInfoFromAPI = true

					this.calcFields.orderVin = resp.vin
					this.calcFields.orderCarYear = resp.makeYear
					carYearSelect.setValue(resp.makeYear)

					this.carMarkSelect__setValue(resp.brand)
					this.carModelSelect__setValue(resp.model)
				})
				.catch((error)=>{
					DEBUG ? console.log(error):null
				})
				.then(()=>{
					govNumEl.classList.remove('_loading')
				})
			},


			checkTypeofSymbols(type, elSelector) {
				const inputField = document.querySelector(elSelector)
				const regex = {
					lat: /[^a-zA-Z0-9\s-]/g,
					cyr: /[^а-яА-ЯіiIІїЇєЄґҐ0-9\s-]/g
					// cyr: /^[\u0400-\u04FF\u0500-\u052F0-9+-]+$/gui
				}
				inputField.value = inputField.value.replace(regex[type], '');
			},



			searchInsurantByPhone() {
				const insurantPhoneWrapEl = document.querySelector('.insurantPhone__wrap')

				const MIN_PHONE_LENGTH = 12
				DEBUG ? console.log('searchInsurantByPhone', 'length: '+this.calcFields.insurantPhone.length ):null
				if(this.calcFields.insurantPhone.length < (MIN_PHONE_LENGTH+1)) return false

				// const SEARCH_INSURANT_BY_PHONE__MODAL = bootstrap.Modal.getInstance(document.querySelector('#modal_searchInsurantByPhone'))
				const SEARCH_INSURANT_BY_PHONE__MODAL = new bootstrap.Modal(document.querySelector('#modal_searchInsurantByPhone'), {backdrop:'static'})
				console.log('SEARCH_INSURANT_BY_PHONE__MODAL', SEARCH_INSURANT_BY_PHONE__MODAL)


				insurantPhoneWrapEl.classList.add('_loading')
				let phone = this.calcFields.insurantPhone
				if (phone.startsWith('+')) phone = phone.slice(1)

				axios.post(API + '/data/search-by-phone', {
					"phone": phone,
				},{
					timeout: 10000,
					headers: {
						'Access-Control-Allow-Origin': 'https://'+window.location.host,
						'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
						'Access-Control-Allow-Headers': '*',
						'Access-Control-Allow-Credentials': 'true',
					}
				})
				.then((response) => {
					DEBUG ? console.log("SEARCH BY PHONE:\n", response, typeof response):null
					if(typeof response == 'object' && response.data.success == true) {
						// let found_insurant =
						SEARCH_INSURANT_BY_PHONE__MODAL.show()

						// this.fillingInsurantByPhone.insurant_data = response.data
					}
				})
				.catch((error)=>{
					DEBUG ? console.warn("ERROR searchInsurantByPhone\n", error):null
				})
				.then(()=>{
					insurantPhoneWrapEl.classList.remove('_loading')
				})
			},



			searchInsurant__sendSms() {
				DEBUG ? console.log('searchInsurant__sendSms'):null
				this.fillingInsurantByPhone.allow = 1
				let phone = this.calcFields.insurantPhone
				if (phone.startsWith('+')) phone = phone.slice(1)

				this.calcStatus.sendSms_searchInsurantByPhone__count += 1

				axios.post(API + '/data/send-sms', {
					"phone": phone,
				},{
					timeout: 10000,
					headers: {
						'Access-Control-Allow-Origin': 'https://'+window.location.host,
						'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
						'Access-Control-Allow-Headers': '*',
						'Access-Control-Allow-Credentials': 'true',
					}
				})
				.then((response) => {
					DEBUG ? console.log("SEND_SMS:\n", response):null
					if(typeof response == 'object' && response.data.success == true) {
						// let found_insurant =
						// SEARCH_INSURANT_BY_PHONE__MODAL.show()
						// this.fillingInsurantByPhone.insurant_data = response.data
					} else {
						throw new Error()
					}
				})
				.catch((error)=>{

					SwalToast.fire({
						html: 'Вибачте, помилка при&nbsp;відправці смс. Спробуйте пізніше або&nbsp;заповніть форму самостійно.',
						icon: 'warning', timer: 7000, position: 'top', backdrop: false, showCloseButton: true, customClass: {popup: 'swal--warning'}
					})


					DEBUG ? console.warn("ERROR searchInsurant__sendSms\n", error):null
					this.log({
						method:'searchInsurant__sendSms',
						error:error,
						error_response:error.response,
						data:this.calcFields
					}, CALC_TYPE+'-error')
				})
			},



			searchInsurant__confirmSmsCode() {
				DEBUG ? console.log('searchInsurant__confirmSmsCode'):null
				let phone = this.calcFields.insurantPhone
				if (phone.startsWith('+')) phone = phone.slice(1)

				axios.post(API + '/data/search-by-phone', {
					"phone": phone,
					"code": this.fillingInsurantByPhone.sms_code
				},{
					headers: {
						'Access-Control-Allow-Origin': 'https://'+window.location.host,
						'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
						'Access-Control-Allow-Headers': '*',
						'Access-Control-Allow-Credentials': 'true',
					}
				})
				.then((response) => {
					DEBUG ? console.log("confirmSmsCode:\n", response):null
					if(typeof response == 'object' && typeof response.data.surname == 'string') {
						this.fillingInsurantByPhone.insurant_data = response.data

						if(typeof response.data.vehicles != 'undefined')
							this.calcFields.vehicles = response.data.vehicles

						this.searchInsurant__fillingInsurant()
					}
				})
				.catch((error)=>{
					DEBUG ? console.warn("ERROR searchInsurant__sendSms\n", error):null

					if(error.response.data.success == false) {
						SwalToast.fire({
							html: 'Смс-код введений неправильно. Спробуйте ще&nbsp;раз або&nbsp;запитайте новий код.',
							icon: 'warning', timer: 20000, position: 'top', backdrop: false, showCloseButton: true, customClass: {popup: 'swal--warning'}
						})


					} else {
						SwalToast.fire({
							html: 'Вибачте, помилка при&nbsp;перевірці смс. Спробуйте пізніше або&nbsp;заповніть форму самостійно.',
							icon: 'warning', timer: 20000, position: 'top', backdrop: false, showCloseButton: true, customClass: {popup: 'swal--warning'}
						})

						this.log({
							method:'searchInsurant__confirmSmsCode',
							error:error,
							error_response:error.response,
							data:this.calcFields
						}, CALC_TYPE+'-error')
					}
				})
			},



			searchInsurant__fillingInsurant() {
				DEBUG ? console.log('searchInsurant__fillingInsurant'):null

				// document.querySelector('#modal_searchInsurantByPhone .btn-close').click()
				const SEARCH_INSURANT_BY_PHONE__MODAL = bootstrap.Modal.getInstance(document.querySelector('#modal_searchInsurantByPhone'))
				SEARCH_INSURANT_BY_PHONE__MODAL.hide()
				DEBUG ? console.log('#modal_searchInsurantByPhone CLOSE'):null

				this.fillingInsurantByPhone.allow = false
				this.fillingInsurantByPhone.sms_code = ''
				this.fillingInsurantByPhone.sms_confirmed = true

				let found_insurant = this.fillingInsurantByPhone.insurant_data
				if(typeof found_insurant.dob == 'string') {
					const [bday, bmonth, byear] = found_insurant.dob.split(".")
					found_insurant.dob_ymd = `${byear}-${bmonth}-${bday}`
				}

				this.calcFields.email = found_insurant.email
				this.calcFields.insurantName = found_insurant.name
				this.calcFields.insurantSurname = found_insurant.surname
				this.calcFields.insurantNameLatin = found_insurant.latin_name
				this.calcFields.insurantSurnameLatin = found_insurant.latin_surname
				this.calcFields.insurantInn = found_insurant.ipn
				// this.calcFields.insurantBirth = found_insurant.dob_ymd
				if(found_insurant.dob_ymd) this.calendarSetDate('#insurantBirth', found_insurant.dob_ymd)

				if(found_insurant.vehicles.length == 1 && typeof found_insurant.vehicles[0] != 'undefined') this.fillingVehicle(0) // если только одно авто - оно заполняется сразу
			},



			fillingVehicle(index) {
				DEBUG ? console.log('fillingVehicle #'+index):null
				const vehicle = this.calcFields.vehicles[index]
				if(typeof vehicle == 'undefined') return false

				DEBUG ? console.log('vehicle:', vehicle):null
				if(vehicle.state_number != '') this.calcFields.gov_num = vehicle.state_number
				if(vehicle.vin != '') this.calcFields.orderVin = vehicle.vin
				if(vehicle.year != '') {
					this.calcFields.orderCarYear = vehicle.year
					let carYearSelect = document.getElementById('carYearSelect').tomselect
					carYearSelect.setValue(vehicle.year);
				}
				if(vehicle.brand != '') {
					this.calcFields.orderCarMark.name = vehicle.brand
					this.carMarkSelect__setValue(vehicle.brand)
					this.carModelSelect__setValue(vehicle.model)
				}
			},



			carMarkSelect__setValue(markName) {
				const value = {id:markName, name:markName}
				DEBUG ? console.log('carMarkSelect__setValue', value) : null
				const carMarkSelect = document.querySelector('#carMarkSelect').tomselect
				carMarkSelect.addOption(value)
				carMarkSelect.setValue(value.name)
				this.calcStatus.isLoadCarInfoFromAPI = false
			},


			carModelSelect__setValue(modelName) {
				const value = {id:modelName, name:modelName}
				DEBUG ? console.log('carModelSelect__setValue', value) : null
				const carModelSelect = document.querySelector('#carModelSelect').tomselect
				carModelSelect.addOption(value)
				carModelSelect.setValue(value.name)
				this.calcStatus.isLoadCarInfoFromAPI = false
			},


			calendarSetDate(selector, ymd) {
				const cal = document.querySelector(selector)._flatpickr
				cal.setDate(ymd, true, 'Y-m-d')
			},


			// tomSelectDropdown__setValue(selector, value) {
			// 	const OTHER_MARK_ID = 581 // Інше авто

			// 	DEBUG ? console.log('tomSelectDropdown__setValue', selector, value):null
			// 	let tomselect = document.querySelector(selector).tomselect
			// 	let find = _.find(tomselect.options, {name:value})
			// 	// let find = _.find(tomselect.options, value)
			// 	DEBUG ? console.log('tomSelectDropdown__setValue FIND:', find, {name:value}):null
			// 	DEBUG ? console.log('tomSelectDropdown__tomselect:', typeof tomselect.options,  tomselect.options):null

			// 	if(find) {
			// 		tomselect.setValue(find)

			// 	} else {
			// 		tomselect.addOption({
			// 			id: OTHER_MARK_ID,
			// 			name: value,
			// 		});
			// 		tomselect.setValue
			// 	}

			// },

			showApiTranslaterdErrors(response_with_error) {

				if(typeof response_with_error.message != 'object') {
					DEBUG ? console.log(response_with_error, typeof response_with_error.message):null
					return false
				}

				const errorMessages = []
				for (const field in response_with_error.message) {
					errorMessages.push(...response_with_error.message[field]);
				}
				let $message = '<ul>'
				errorMessages.forEach(function(row_string) {
					$message += "<li>" + row_string + "</li>";
				})
				$message += '</ul>'


				Swal.fire({
					title: 'Увага',
					html: $message,
					customClass: {popup: 'swal--text_left'},
					confirmButtonText: `Зрозуміло`,
					icon: 'warning', backdrop: false, showCloseButton: true
				})
			},



			showServerError() {
				showServerError()
			},



			checkIsWelcomeLink() {
				const WELCOME_LINK_PARAM = 'ph'
				let $_GET = new URLSearchParams(window.location.search)
				if ($_GET.has(WELCOME_LINK_PARAM)) {
					const WELCOME_LINK_VALUE = $_GET.get(WELCOME_LINK_PARAM)

					axios.post(API + '/data/search-by-hash', {
							"hash": WELCOME_LINK_VALUE
						},{
							headers: {
								'Access-Control-Allow-Origin': 'https://'+window.location.host,
								'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
								'Access-Control-Allow-Headers': '*',
								'Access-Control-Allow-Credentials': 'true',
							}
						})

						.then((response) => {
							DEBUG ? console.log("checkIsWelcomeLink:\n", response):null
							if(response.success === false) throw new Error('Error checkIsWelcomeLink()')

							let data = response.data
							this.calcFields.insurantName = data.name
							this.calcFields.insurantSurname = data.surname
							this.calcFields.insurantNameLatin = data.latin_name
							this.calcFields.insurantSurnameLatin = data.latin_surname
							// this.calcFields.insurantBirth =
							this.calcFields.insurantInn = data.ipn
							this.calcFields.insurantPhone = data.phone
							this.calcFields.email = data.email
							this.calcFields.vehicles = data.vehicles

							const y_m_d = moment(data.dob, 'DD.MM.YYYY').format('YYYY-MM-DD')
							DEBUG ? console.log('DOB: ', y_m_d):null
							if(data.dob) this.calendarSetDate('#insurantBirth', y_m_d)

							window.intlTelInput(document.querySelector("#phone")).setNumber('+'+data.phone)
							// document.querySelector("#phone").dispatchEvent(new Event('change'))
							// DEBUG ? console.log('zz', document.querySelector("#phone").value):null

							if(data.vehicles.length == 1 && typeof data.vehicles[0] != 'undefined') this.fillingVehicle(0) // если только одно авто - оно заполняется сразу
						})

						.catch((error)=>{
							DEBUG ? console.log("ERROR checkIsWelcomeLink\n", error):null
							this.log({
								method:'checkIsWelcomeLink',
								error:error,
								error_response:error.response,
								data:this.calcFields
							}, CALC_TYPE+'-error')
						})
				}
			},



			checkIsTest() {
				const $_GET = new URLSearchParams(window.location.search);
				if($_GET.get('test') != null) {
					setTimeout(()=>{
						axios.get(CALC_URL + '/'+CALC_TYPE+'/test.php?test=' + $_GET.get('test'))
						.then((response) => {
							let testData = response.data
							DEBUG ? console.log("GET test\n", CALC_URL + 'test.php?test=' + $_GET.get('test'), testData):null
							if(testData.result === false) throw new Error('Error checkIsTest()')
							this.calcFields = testData
							this.getPrice()
						})
						.catch((error)=>{
							DEBUG ? console.log("ERROR get test\n", error):null
							this.log({
								method:'checkIsTest',
								error:error,
								error_response:error.response,
								data:this.calcFields
							}, CALC_TYPE+'-error')
						})
					},500)
				}
			},


			updateCashbackBankCard(event) {
				this.calcFields.cashback.bankcard.value = event.target.value
				DEBUG ? console.log('updateCashbackBankCard:', this.calcFields.cashback.bankcard.value) : null
			},


			log($data, $filename = CALC_TYPE+'-error') {
				if($data !== null && $data.constructor.name === " Object")
					$data = JSON.stringify($data)

				DEBUG ? console.log("LOG DATA:\n", $data, "LOG FILENAME:\n", $filename):null
				axios.post(CALC_URL + '/'+CALC_TYPE+'/log.php', {
					"data": $data,
					"filename": $filename
				},{
					headers: {
						'Access-Control-Allow-Origin': 'https://'+window.location.host,
						'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
						'Access-Control-Allow-Headers': '*',
						'Access-Control-Allow-Credentials': 'true',
					}
				})
				.then((response) => {
					DEBUG ? console.log("SAVE LOG\n", response):null
				})
			},
		},


		watch: {
			'calcFields.trip_duration'(val) {
				const tripDuration = {
					0: '15 днів',
					1: '1 місяць',
					2: '2 місяці',
					3: '3 місяці',
					4: '4 місяці',
					5: '5 місяці',
					6: '6 місяці',
					7: '7 місяці',
					8: '8 місяці',
					9: '9 місяці',
					10: '10 місяців',
					11: '11 місяців',
					12: '12 місяців',
				}
				this.calcFields.trip_duration_days = tripDuration[val]
			},

			'calcFields.insurantPhone'(val) {
				checkAndChangeCashbackPhone(this, 'watch')
				// this.searchInsurantByPhone()
			},

			// 'calcFields': {
			// 	handler(newVal, oldVal) {
			// 		this.saveDraft()
			// 	},
			// 	deep: true
			// },
		},



		// created() {

		// },


		mounted() {
			const appContainer = document.getElementById('calc')
			const appContainerWrap = document.querySelector('.calc__wrap')
			appContainerWrap.classList.add("loaded")

			this.checkIsTest()
			// this.getDefaultCities()

			if(this.calcStatus.enableAssist == false) {
				this.calcFields.assistme.need = false
			}

			// бывший created
			this.getPrice()
			this.checkIsWelcomeLink()

			// Для брошенной корзины
			document.querySelectorAll('#calc input, #calc select, #calc textarea').forEach((element)=>{
				element.addEventListener('change', async()=> {
					if(
						(this.calcFields.insurantPhone != '' && this.calcFields.email != '')
						|| (this.uuid === '' && this.uuid !== false)
					) await this.saveDraft()
				})
			})
		},
	})


	APP.directive('inputmaskbankcard', {mounted(el, binding) {
		new Inputmask({"mask": "9999-9999-9999-9999"}).mask(el)
	}})


	APP.directive('popover', {mounted(el, binding) {
		// $(el).popover()
		let popId = el.dataset.popoverId
		popovers[popId] = new bootstrap.Popover(el,  {
			container: '#calc'
		})
	}})



	APP.directive('calendar', {mounted(el, binding) {
		const flatpickrArgsDefault = {
			disableMobile: "true",
			altInput: true,
			allowInput: true,
			altFormat: "d.m.Y",
  		dateFormat: "Y-m-d",
			"locale": "uk"
		}

		let flatpickrArgs = typeof binding.value !== 'undefined'
			?	binding.instance.getCalendarInitParams(binding.value.init) // APP
			: {}

			flatpickrArgs = _.merge(flatpickrArgsDefault, flatpickrArgs)

		window[el.id] = flatpickr(el, flatpickrArgs);
		if(el.id == 'polisStart') {
			window.polisStart.setDate(defaultOrderPolisStart, true, 'Y-m-d')
		}
	}})


	APP.directive('smartselect', {mounted(el, binding) {
		const selectArgsDefault = {
			maxOptions: 100,
			render:{
				option_create: function(data, escape) {
					return '<div class="create">Вибрати <strong>' + escape(data.input) + '</strong>&hellip;</div>';
				},
				no_results:function(data,escape){
					return '<div class="no-results">Не знайдено</div>';
				}
			}
		}


		let selectArgs = typeof binding.value !== 'undefined'
			?	binding.instance.getTomSelectInitParams(binding.value.init, binding.instance) // APP
			: {}

		selectArgs = _.merge(selectArgsDefault, selectArgs)

		new TomSelect(el, selectArgs)
		// Костыль для объявления глобальной переменной
		// window['select__'+el.id] = new TomSelect(el, selectArgs)
	}})



	APP.directive('phonemask', {mounted(el, binding) {
		const defaults = {
			// initialCountry: "Ua",
			// separateDialCode: true,
			// autoHideDialCode: false,
			// utilsScript: CALC_URL+"/assets/js/utils.js"
			initialCountry: "ua",
			showSelectedDialCode: true,
			countrySearch: false,
			utilsScript: CALC_URL+"/assets/js/utils.js"
		}

		let initArgs = typeof binding.value !== 'undefined'
			?	binding.value
			: {}

		const args = _.merge(defaults, initArgs)

		window[el.id] = intlTelInput(el, args)


		let el_phone = document.querySelector('#phone')

		"change countrychange keyup".split(" ").forEach(function(e){
			el_phone.addEventListener(e, ()=>{
				checkAndChangeCashbackPhone(binding.instance, e)

			},false)
		})
	}})


	function checkAndChangeCashbackPhone($app) {
		let el_phone = document.getElementById('phone')
		let el_cashbackPhone = document.getElementById('cashbackPhone')
		const phone = getPhoneNumbers(el_phone)

		if(typeof el_cashbackPhone == 'undefined') return false

		$app.calcFields.insurantPhone = phone.full
		el_phone.value = phone.short

		DEBUG ? console.log('checkAndChangeCashbackPhone: ', phone):null

		if($app.calcFields.cashback_phone_changed == false) {
			if(phone.countryCode == '+380' && (phone.short.trim()).charAt(0) != '+' && phone.short.length == 9 && $app.calcFields.trip_country != 'sng') {
				$app.calcFields.cashback.phone.value = phone.short
				el_cashbackPhone.value = phone.short
			}
		}
	}



	function getPhoneNumbers(el) {
		let $return = {}

		$return.full = window[el.id].getNumber(intlTelInputUtils.numberFormat.E164)
		$return.countryCode = '+'+window[el.id].getSelectedCountryData().dialCode
		$return.short = $return.full.replace($return.countryCode, '')

		return $return
	}


	APP.mount('#calc')
})
